import Box from '@mui/material/Box'
import {Text} from '../1elements'

const NoData = () => {
    return (
        <Box
            sx={{
                alignItems: 'center',
                display: 'flex',
                height: '100%',
                justifyContent: 'center',
                width: '100%'
            }}
        >
            <Text type={'h2'}>No Data To Show</Text>
        </Box>
    )
}

export default NoData
